import { getDBContentCollections } from '../utils/collections';
import { CollectionTypes } from '~/types/adamTypes';
import type { UserContent } from '~/types/app';
import type { DataShouldSyncResult } from '~/lib/sync/shouldSyncUserContents';

export const isContentInUserLibs = (contents: UserContent[], id) => {
  return contents.findIndex((item) => item.id === id) > -1;
};

export const isMainContent = (contents: UserContent[], id) => {
  return (
    contents.findIndex(
      (item) => item.id === id && item.type === UserContentType.MainContent
    ) > -1
  );
};

export const isContentInUserLibsButNotAsChild = (
  contents: UserContent[],
  id
) => {
  return (
    contents.findIndex(
      (item) => item.id === id && item.type !== UserContentType.ChildrenContent
    ) > -1
  );
};

export const getIdFromSlug = (contents: UserContent[], slug): string | null => {
  const content = contents.find((content) => content.slug === slug);
  if (content) {
    return content.id;
  } else {
    return null;
  }
};

export const getContentsOfMemberId = (
  contents: UserContent[],
  memberId: string
) => {
  return contents.find((content) => content.memberId === memberId);
};

export const getContentPathFromId = (
  contents: UserContent[],
  id: string
): string | null => {
  const content = contents.find((content) => content.id === id);

  return content?.path;
};

export const getContentFromId = (
  contents: UserContent[],
  id: string
): UserContent => {
  const content = contents.find((content) => content.id === id);

  return content;
};

export const getUserContentsMap = (
  userContents: UserContent[]
): Map<string, UserContent> => {
  return new Map<string, UserContent>(
    userContents.map((content) => [content.id, content])
  );
};

export const getIdsFromUserContents = (
  userContents: UserContent[]
): string[] => {
  return userContents.map((c) => c.id);
};

export const getUserContentUpadeParamsFromShouldSyncResults = (
  contents,
  shouldSyncResults: DataShouldSyncResult[]
) => {
  const lImportParams: ContentImportParams[] = [];
  contents.forEach((content) => {
    const shouldSync = shouldSyncResults.find(
      (shouldSync) => shouldSync.libraryBookId === content.id
    );

    if (shouldSync && shouldSync.collections.length > 0) {
      const params = getUserContentUpadeParams(content, shouldSync.collections);

      lImportParams.push(params);
    }
  });
  return lImportParams;
};

export const getUserContentUpadeParams = (
  content: UserContent,
  collections: CollectionTypes[] = getDBContentCollections()
): ContentImportParams => {
  return {
    libraryBookId: content.id,
    collections,
    segmented: content.segmented ? content.segmented : 0,
    adaptive: 0,
  };
};

export const getUserContentsFullUpdateParams = (
  contents: UserContent[]
): ContentImportParams[] => {
  const params = contents.map((content) => getUserContentUpadeParams(content));
  return params;
};
